import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RelatedCompaniesService } from './related-companies.service';
import { RelatedCompaniesListComponent } from './related-companies-list.component';

@Component({
    selector: 'app-related-companies-delete',
    templateUrl: './related-companies-delete.component.html',
    styleUrls: ['./related-companies-delete.component.css'],
    standalone: false
})
export class RelatedCompaniesDeleteComponent {

  uid: number = this.data.uid;
  type: string = this.data.type;
  error_msg: string;
  error: boolean = false;

  constructor(
    public relatedCompaniesService: RelatedCompaniesService,
    public dialogRef: MatDialogRef<RelatedCompaniesListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  delete() {
    this.relatedCompaniesService.deleteData(this.uid);
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
